import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, " This page is intended for all Empowered Consumerism Partners who missed to purchase their PMA last month and therefore unable to earn their commissions for this month. ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Requirement:"),
  /*#__PURE__*/_createVNode("b", { class: "seq-notice__emphasis-success" }, "You have to purchase DOUBLE MAINTENANCE.")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, "Minimum PMA for DI / SE / GE / GA - 0.6668 Positional Points", -1)
const _hoisted_6 = { class: "card-title align-items-center mb-5" }
const _hoisted_7 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Your Inventory", -1)
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Product"),
    /*#__PURE__*/_createVNode("th", null, "Quantity"),
    /*#__PURE__*/_createVNode("th", null, "Position"),
    /*#__PURE__*/_createVNode("th", null, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4" }, "Action")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createVNode("td", {
  colspan: "5",
  class: "text-center text-muted py-10"
}, "No inventory items found.", -1)
const _hoisted_14 = { class: "ps-4" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_17 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_18 = { class: "fw-semibold text-gray-800" }
const _hoisted_19 = { class: "text-muted fs-8" }
const _hoisted_20 = {
  key: 0,
  class: "text-danger fs-8"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" This product is ")
const _hoisted_22 = /*#__PURE__*/_createVNode("u", null, "NOT", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" PMA of the month. ")
const _hoisted_24 = /*#__PURE__*/_createVNode("option", { value: "L" }, "Left", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("option", { value: "R" }, "Right", -1)
const _hoisted_26 = { class: "pe-4" }
const _hoisted_27 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_28 = {
  key: 1,
  href: "javascript:void(0);",
  class: "btn btn-sm btn-seq-green"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_EstoreExpiry = _resolveComponent("EstoreExpiry")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_SeqNoticeCard, {
            variant: "warning",
            title: "Please Note!",
            class: "mb-6"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode("h3", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Box2.svg" })
            ]),
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("table", _hoisted_10, [
              _hoisted_11,
              _createVNode("tbody", null, [
                (_ctx.list.length === 0)
                  ? (_openBlock(), _createBlock("tr", _hoisted_12, [
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _createVNode("span", _hoisted_16, [
                          _createVNode("span", _hoisted_17, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Box2.svg" })
                          ])
                        ]),
                        _createVNode("div", null, [
                          _createVNode("div", _hoisted_18, _toDisplayString(item.product.toUpperCase()), 1),
                          _createVNode("div", _hoisted_19, "Remaining: " + _toDisplayString(Math.round(item.quantity)), 1),
                          (item.isPMAOfTheMonth != 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                _hoisted_21,
                                _hoisted_22,
                                _hoisted_23
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "seq-table-control seq-table-control--qty",
                        type: "text",
                        id: 'store_count_' + item.prodcode,
                        "onUpdate:modelValue": ($event: any) => (_ctx.store_count[index] = $event)
                      }, null, 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelText, _ctx.store_count[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("select", {
                        class: "seq-table-control seq-table-control--pos",
                        id: 'pos_' + item.prodcode,
                        "onUpdate:modelValue": ($event: any) => (_ctx.pos[index] = $event)
                      }, [
                        _hoisted_24,
                        _hoisted_25
                      ], 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelSelect, _ctx.pos[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "seq-table-control seq-table-control--usid",
                        type: "text",
                        id: 'tousid_' + item.prodcode,
                        "onUpdate:modelValue": ($event: any) => (_ctx.tousid[index] = $event)
                      }, null, 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelText, _ctx.tousid[index]]
                      ]),
                      _createVNode("input", {
                        type: "hidden",
                        id: 'prodcode_' + item.prodcode
                      }, null, 8, ["id"])
                    ]),
                    _createVNode("td", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        (_ctx.isprocessing[index] === '0')
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "javascript:void(0);",
                              onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index);},
                              class: "btn btn-sm btn-seq-green"
                            }, "Send", 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.isprocessing[index] === '1')
                          ? (_openBlock(), _createBlock("a", _hoisted_28, "Processing..."))
                          : _createCommentVNode("", true),
                        (_ctx.isBCOAccount == false)
                          ? (_openBlock(), _createBlock("button", {
                              key: 2,
                              type: "button",
                              class: "btn btn-sm btn-seq-blue",
                              "data-bs-toggle": "modal",
                              "data-bs-target": `#kt_modal_estore_expiry`,
                              onClick: ($event: any) => {_ctx.viewExpiryDate(item.prodcode, item.product);}
                            }, "Expiry Date", 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_EstoreExpiry, {
            "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8",
            pname: _ctx.modal_prodname,
            list2: _ctx.expiry_list
          }, null, 8, ["pname", "list2"])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading && _ctx.isShowRetroPMAButton]
    ])
  ], 64))
}